import { Badge } from '@/components/ui/badge';
import {
  FINDING_SCORE_THRESHOLD,
  HIGH_SCORE_THRESHOLD,
} from '@/components/policylist/constants/builtin-catalog';
import type { ReactElement } from 'react';

interface AggregateScoreChipProps {
  score?: number;
}

function scoreVariant(score: number): 'default' | 'secondary' | 'destructive' {
  if (score >= HIGH_SCORE_THRESHOLD) return 'destructive';
  if (score >= FINDING_SCORE_THRESHOLD) return 'default';
  return 'secondary';
}

/**
 * Catalog aggregate score. This intentionally does not use alert.score, which
 * is derived from alert severity rather than catalog contributors.
 */
export function AggregateScoreChip({
  score,
}: AggregateScoreChipProps): ReactElement | null {
  if (score === undefined) return null;

  return <Badge variant={scoreVariant(score)}>Aggregate score {score}</Badge>;
}

AggregateScoreChip.displayName = 'AggregateScoreChip';
